
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"18","height":"18","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAJElEQVQ4jWP8////fwYqACZqGMIwatCoQaMGjRo0WAxiYGAAAMw0BCAaOmKdAAAAAElFTkSuQmCC"}}),_c('image',{attrs:{"width":"18","height":"18","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAACo0lEQVQ4jY2UXUgUURTHf3dmdjZdW0swzNhMyiwpsrCgCOultyT6ekifrNdeIijoqYKgoHosoiKhL4I+HgyCLCKpHkqhqDQR+0CyL9pd90udnbk3ZnZdGz+o/8Nw59xz/ud/7rn3CKWUYhJkYhjrRSfW6y6cL5+8Tb2qGrO+AXNDI1q4dHIIPiJlWWRutDFy+xoqnQZd93s7DiIUomhXC8XNrQjTnEqkMlHihw5i97wFTZuS0QcpMepWMufMeURwlrdjeF85ivN+G0b5Z2wxPxciHURJGH1BJCfm6yAqlQAtp9Jcux5hBifoXUX2wDFldejKehxQiaMR9WvrJpW5f1fJkRE1Dnft2ty9VNsFNRlCWr+V/XwxOOkcs1GKXvcMrbx2+qpiUbS5ZVPsmvrVDnYyL0+iLzk5I4kXMA2Jl1/FnoLIH25gDlrFHp+D5SiO3LKw7Cm3pIA1i3QMle4tGERRLejFPicloWfIYSw7Iw9ZG/7R5/+HQWgZJLtz2Uf6wMn4VLlV11XqvtJsCX3fZOG/qlxgaHM343y7movIxpE/bqJV7is4mbrgdHPQJ+3BG5veIQtNgCOhvkpHE+VNYMwupJf9h/md7J+xpo/ROOceZT0SF6EgbKhxiQJlaAsPeKcqUFxMzGfHw+PcG+hg1B4rELhr17b3yX5ioTtuVqSC3esChItE/q3JUbLdW7j0PcblzDKvA46ShM0SIiUVHtFg6jsJK4XuXRVJILqd1cW7OdsSxDRE/q1ps3BWtfMyfgrSfV6JbkA6m+FD7GNBVY4ET8nSmh5ObBQeiXcqf48Ry8lypfcO1/vaPRJd+MeIoxxCgWJaaptoXb4TUw9MdHe6wTY8lqRz6BVdP9/xaXjQs1WXRmiYt4LGyrWUBvPNGQfwB6UpNViZTIR2AAAAAElFTkSuQmCC"}})])
          )
        }
      }
    